export const hotkeyOne = "_GoMAd";
export const hotkeyTwo = "AWPJDd";
export const hotkeyThree = "SW2gQd";
export const hotkeyFour = "Ck4kQd";
export const hotkeyFive = "eqeRMd";
export const hotkeySix = "KIj6Cd";
export const hotkeySeven = "Tv16Le";
export const hotkeyEight = "HkQ8Ge";
export const hotkeyNine = "WUL9ab";
export default {hotkeyOne,hotkeyTwo,hotkeyThree,hotkeyFour,hotkeyFive,hotkeySix,hotkeySeven,hotkeyEight,hotkeyNine};